import { getLogger } from "@rivetkit/core/log";

export const logger = () => getLogger("redis-coordinate");
